import Image from 'components/molecules/Image';
import laschoolImg from './laschool.png';
import { ImageProps } from 'next/legacy/image';

function LaschoolLogo(props: Omit<ImageProps, 'src' | 'alt'>) {
  return <Image width={100} height={100 * (682 / 1024)} {...props} src={laschoolImg} alt="라스쿨PT 로고" />;
}

export default LaschoolLogo;
